import { environment } from '../../environments/environment';

export class AppSettings {
  public static getEnvironmentVariable(key: any) {
    return environment[key];
  }
}
